import React, { useMemo } from 'react';
import t from 'react-translate';
import { Button } from 'react-bootstrap';
import { config as pendoConfig } from '@config/pendo.config.json';

import { css } from '@emotion/react';
import { standardSpacing } from 'styles/global_defaults/scaffolding';

import CloneSourceProgramInfo from './clone-source-program-info';

import { useCloneMentorshipProgram } from '../state/context';
import {
  CloneMentorshipProgramActionType,
  CloneMentorshipProgramWizardStep,
} from '../state/types';

const CloneMentorshipProgramStepThree = () => {
  const { state, dispatch } = useCloneMentorshipProgram();
  const dataQATag = pendoConfig.pendo.athena.mentorshipProgram.cloneProgramModal;
  const translationBase = t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.STEPS.STEP_THREE;

  if (!state.sourceProgram) return null;

  const { targetConfig, admins, selectedAdmins } = state;

  const selectedCount = useMemo(
    () => admins.filter((admin) => selectedAdmins[String(admin.id)]).length,
    [admins, selectedAdmins],
  );

  const handleEdit = () => {
    dispatch({
      type: CloneMentorshipProgramActionType.SET_STEP,
      payload: CloneMentorshipProgramWizardStep.CONFIG,
    });
  };

  return (
    <div>
      <div
        className='d-flex align-items-center mb-4'
      >
        <span className='bold text-regular'>
          {translationBase.CLONED_PROGRAM_SECTION_TITLE()}
        </span>
        <Button
          variant='link'
          onClick={handleEdit}
          className='p-0 ml-2'
          data-qa={dataQATag.editProgramButton}
        >
          {translationBase.EDIT()}
        </Button>
      </div>
      <CloneSourceProgramInfo
        sourceProgram={state.sourceProgram}
        programDataOverride={{
          name: targetConfig.name,
          releasedDate: targetConfig.releasedDate,
          adminsCount: selectedCount,
        }}
      />
    </div>
  );
};

export default CloneMentorshipProgramStepThree;
